import { render, staticRenderFns } from "./WikiTextArea.vue?vue&type=template&id=131ee411&scoped=true"
import script from "./WikiTextArea.vue?vue&type=script&lang=js"
export * from "./WikiTextArea.vue?vue&type=script&lang=js"
import style0 from "./WikiTextArea.vue?vue&type=style&index=0&id=131ee411&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131ee411",
  null
  
)

export default component.exports